import React from "react";
import styled from 'styled-components';
import { variables, devices, colors } from "../../assets/styles/variables";

const Section = styled.div`
    max-width: ${variables.maxWidth};
    position: relative;
    margin: 0px auto;

    width: calc(100% - 30px);
    height: 100%;
    padding: 0px 15px;

    // Delete this /////////////////////
    // border-left: 1px dashed lightgrey;
    // border-right: 1px dashed lightgrey;
    ////////////////////////////////////
  
    @media ${devices.sizeMobile} { 
        width: calc(100% - 30px);
        padding: 0px 15px;
    }
    
    @media ${devices.sizeTablet} { 
        width: calc(100% - 30px);
        padding: 0px 15px;
    }
    
    @media ${devices.sizeLaptop} { 
        width: calc(100% - 30px);
        padding: 0px 15px;
    }

`;

const ContainerCol = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: start;
    flex-wrap: wrap;
    &.center { align-items: center; }
    &.reverse { flex-direction: column-reverse; }
    @media ${devices.sizeTablet} {
        &.reverse { flex-direction: column; }
    }
`;

const ContainerRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: start;
    flex-wrap: wrap;
    &.center { align-items: center; }
    &.reverse { flex-direction: row-reverse; }
    @media ${devices.sizeTablet} {
        &.reverse { flex-direction: row; }
    }
`;

const Item = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    flex-wrap: wrap;
`;

export const Container = ({ children, className = '' }) => {
    return (
        <Section className={className} >{children}</Section>
    )
}

export const Col = ({ gap = '0px', children, className = '' }) => {
    return (
        <ContainerCol style={{gap}} className={className} >{children}</ContainerCol>
    )
}

export const Row = ({ gap = '0px', children, className = '' }) => {
    return (
        <ContainerRow style={{gap}} className={className} >{children}</ContainerRow>
    )
}

export const FormItem = ({ children, className = '' }) => {
    return (
        <Item className={className} >{children}</Item>
    )
}